<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/WC5Mft/tc-custom/9781426846144.jpg?1704281352195" alt="This image is the cover for the book Desert Prince, Bride of Innocence"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Desert Prince, Bride of Innocence
      </h1>
      <p class="bookDescription body article font2">
        <b>The king’s brother stirs up scandal with an innocent nanny in this royal romance by a <i>USA Today</i>–bestselling author.</b><br/><br/>Prince Jasim bin Hamid al Rais was concerned that his womanizing elder brother was bewitched by his child’s nanny—the throne of Quaram could be threatened by scandal! Though Elinor Tempest appeared to be a fragile beauty, Jasim wasn’t fooled; he’d deal with this strumpet himself. . . . <br/><br/>Only after he’d ruthlessly seduced her did Jasim discover Elinor really had been a virgin—and she’d fallen pregnant! A royal baby couldn’t be born out of wedlock so, faster than the desert wind, Elinor became Jasim’s unwanted bride. . . . <br/><br/><i>Originally published in 2009.</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lynne Graham
      </h2>
      
      <p class="authorDescription body article">Lynne Graham lives in Northern Ireland and has been a keen romance reader since her teens. Happily married, Lynne has five children. Her eldest is her only natural child. Her other children, who are every bit as dear to her heart, are adopted. The family has a variety of pets, and Lynne loves gardening, cooking, collecting allsorts and is crazy about every aspect of Christmas.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?18b0d1b2